//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const CONFIGURATION_API_BASE_URL = new InjectionToken<string>('CONFIGURATION_API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class ConfigurationFunctionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getCompanyInfo(): Observable<CompanyInfo> {
        let url_ = this.baseUrl + "/api/CompanyInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyInfo>;
        }));
    }

    protected processGetCompanyInfo(response: HttpResponseBase): Observable<CompanyInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCompanyPayorInfo(companyCode: string, payor: string): Observable<CompanyInfo> {
        let url_ = this.baseUrl + "/api/CompanyInfo/{companyCode}/payor/{payor}";
        if (companyCode === undefined || companyCode === null)
            throw new Error("The parameter 'companyCode' must be defined.");
        url_ = url_.replace("{companyCode}", encodeURIComponent("" + companyCode));
        if (payor === undefined || payor === null)
            throw new Error("The parameter 'payor' must be defined.");
        url_ = url_.replace("{payor}", encodeURIComponent("" + payor));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyPayorInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyPayorInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyInfo>;
        }));
    }

    protected processGetCompanyPayorInfo(response: HttpResponseBase): Observable<CompanyInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAppConfig(): Observable<void> {
        let url_ = this.baseUrl + "/api/CompanyInfo/config";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAppConfig(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getLogicAppConfiguration(): Observable<void> {
        let url_ = this.baseUrl + "/api/CompanyInfo/logicappconfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLogicAppConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogicAppConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetLogicAppConfiguration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getFeaturesByApplicationAndCompany(applicationName: string, companyCode: string): Observable<CompanyInfo> {
        let url_ = this.baseUrl + "/api/config/{applicationName}/{companyCode}";
        if (applicationName === undefined || applicationName === null)
            throw new Error("The parameter 'applicationName' must be defined.");
        url_ = url_.replace("{applicationName}", encodeURIComponent("" + applicationName));
        if (companyCode === undefined || companyCode === null)
            throw new Error("The parameter 'companyCode' must be defined.");
        url_ = url_.replace("{companyCode}", encodeURIComponent("" + companyCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeaturesByApplicationAndCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeaturesByApplicationAndCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyInfo>;
        }));
    }

    protected processGetFeaturesByApplicationAndCompany(response: HttpResponseBase): Observable<CompanyInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getFeaturesByApplicationAndAllCompanies(applicationName: string): Observable<CompanyInfo> {
        let url_ = this.baseUrl + "/api/config/{applicationName}/global";
        if (applicationName === undefined || applicationName === null)
            throw new Error("The parameter 'applicationName' must be defined.");
        url_ = url_.replace("{applicationName}", encodeURIComponent("" + applicationName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeaturesByApplicationAndAllCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeaturesByApplicationAndAllCompanies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyInfo>;
        }));
    }

    protected processGetFeaturesByApplicationAndAllCompanies(response: HttpResponseBase): Observable<CompanyInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getComponent(): Observable<ComponentDto[]> {
        let url_ = this.baseUrl + "/api/config/component";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComponent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComponent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComponentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComponentDto[]>;
        }));
    }

    protected processGetComponent(response: HttpResponseBase): Observable<ComponentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComponentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getConfigurationDetails(body?: ConfigurationFetchRequest | undefined): Observable<ConfigurationDto[]> {
        let url_ = this.baseUrl + "/api/config/configurationdetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfigurationDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfigurationDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigurationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigurationDto[]>;
        }));
    }

    protected processGetConfigurationDetails(response: HttpResponseBase): Observable<ConfigurationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConfigurationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertConfigurationDetails(body?: ConfigurationDetailsRequest | undefined): Observable<ConfigurationDetailsResponse> {
        let url_ = this.baseUrl + "/api/config/configurationdetails/upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertConfigurationDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertConfigurationDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigurationDetailsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigurationDetailsResponse>;
        }));
    }

    protected processUpsertConfigurationDetails(response: HttpResponseBase): Observable<ConfigurationDetailsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigurationDetailsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getFunctionalGroup(authAgreementNumber: number): Observable<FunctionalGroup[]> {
        let url_ = this.baseUrl + "/api/config/functionalgroup/{authAgreementNumber}";
        if (authAgreementNumber === undefined || authAgreementNumber === null)
            throw new Error("The parameter 'authAgreementNumber' must be defined.");
        url_ = url_.replace("{authAgreementNumber}", encodeURIComponent("" + authAgreementNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFunctionalGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFunctionalGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FunctionalGroup[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FunctionalGroup[]>;
        }));
    }

    protected processGetFunctionalGroup(response: HttpResponseBase): Observable<FunctionalGroup[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FunctionalGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getV4RoleScreensConfiguration(): Observable<V4RoleScreensConfig> {
        let url_ = this.baseUrl + "/api/config/v4rolescreens";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetV4RoleScreensConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetV4RoleScreensConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<V4RoleScreensConfig>;
                }
            } else
                return _observableThrow(response_) as any as Observable<V4RoleScreensConfig>;
        }));
    }

    protected processGetV4RoleScreensConfiguration(response: HttpResponseBase): Observable<V4RoleScreensConfig> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = V4RoleScreensConfig.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    ping(): Observable<void> {
        let url_ = this.baseUrl + "/api/Ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AddressConfig implements IAddressConfig {
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    latitude?: number;
    longitude?: number;

    constructor(data?: IAddressConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): AddressConfig {
        data = typeof data === 'object' ? data : {};
        let result = new AddressConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface IAddressConfig {
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    latitude?: number;
    longitude?: number;
}

export class CompanyConfiguration implements ICompanyConfiguration {
    initialExternalShiftStatus?: number;
    wwlDefault?: number;
    defaultPTOServiceCode?: string | undefined;
    glUnappliedPaymentProgramWorkTag?: string | undefined;
    testServiceCode?: string | undefined;
    defaultTestAuthEndDateOffset?: number;
    otFrequencyHours?: number;
    cellTrakDelayedHours?: number;
    weekStartDay?: string | undefined;
    weekEndDay?: string | undefined;
    wwlTemporaryLessThanPermanentAllowed?: boolean;
    timeZone?: TimeZoneConfig;
    liveInModifier?: string | undefined;
    defaultEmployer?: DefaultEmployer;
    defaultPayor?: string | undefined;
    cdwaPhoneNumber?: string | undefined;
    bccuPhoneNumber?: string | undefined;
    dshsPhoneNumber?: string | undefined;
    mrcPhoneNumber?: string | undefined;
    contactPhoneNumbers?: { [key: string]: string; } | undefined;
    contactAddress?: { [key: string]: string; } | undefined;
    relationshipAttestationPhoneNumber?: string | undefined;
    attestationVersion?: number;
    docAttestationVersion?: number;
    ficaAttestationVersion?: number;
    leAttestationVersion?: number;
    requiredAttestationTypes?: string[] | undefined;
    v4AdditionalRelationshipDisplayDays?: number;
    mileageServiceCodes?: MileageServiceCodes;
    additionalConfigs?: { [key: string]: any; } | undefined;
    personTypeConfiguration?: { [key: string]: PersonTypeConfiguration; } | undefined;
    gracePeriodConfiguration?: GracePeriodConfiguration;
    weeklyOvertimeCutoff?: number;
    dailyOvertimeCutoff?: number;
    overtimeMultiplier?: number;
    holidayMultiplier?: number;
    payStubExternalUrl?: string | undefined;
    accountNotificationEmail?: string | undefined;
    cosmosCollection?: string | undefined;
    autoAdminTimeExemptServiceCodes?: string[] | undefined;
    authExpirationGracePeriodDays?: number;
    adjustCchBatchSize?: number;
    persistPayrollBatchSize?: number;
    updateBillingBatchSize?: number;
    updateCareerBatchSize?: number;
    updateHolidayBatchSize?: number;
    defaultAddress?: AddressConfig;
    outsideGeofenceAddress?: AddressConfig;
    geofenceDistanceFeet?: number;
    backoffTime?: number;
    maxAdjustmentBatchSize?: number;
    maxSyncTime?: number;
    maxSyncBatchSize?: number;
    staticIvrPin?: string | undefined;
    excludedHcpcsBillCodes?: string[] | undefined;
    maxAutoAdminSyncTimeInMinutes?: number | undefined;
    requiredExternalMappingIds?: string[] | undefined;
    timeShiftDocTypeThresholds?: ThresholdRulesConfig;
    feeDocTypeThresholds?: ThresholdRulesConfig;
    mileageDocTypeThresholds?: ThresholdRulesConfig;
    ghsDocTypeThresholds?: ThresholdRulesConfig;
    ghaDocTypeThresholds?: ThresholdRulesConfig;
    paymentJsonFolderName?: string | undefined;
    blobStorageContainerName?: string | undefined;
    emptyBlobName?: string | undefined;
    notificationRecipients?: string[] | undefined;
    allowedDomainEvents?: string[] | undefined;
    serviceDateEvents?: string[] | undefined;
    b2COnboardingEmailNotificationPersonTypes?: string[] | undefined;
    b2CEmailUpdateEmailNotificationPersonTypes?: string[] | undefined;
    b2COnboardingPersonTypes?: string[] | undefined;
    b2CEmailUpdatePersonTypes?: string[] | undefined;
    ssnValidationPersonTypes?: string[] | undefined;
    activeTestShiftRoles?: string[] | undefined;
    serviceCutoffConfiguration?: PayorServiceCutoff[] | undefined;
    ssnValidationSuccess?: { [key: string]: string; } | undefined;
    ssnValidationOverridePersonTypes?: string[] | undefined;
    ssnValidationFailureContactNumber?: string | undefined;
    integrationJobSenderUserName?: string | undefined;
    integrationJobSenderEmail?: string | undefined;
    integrationJobGroupStatusChangeRecipients?: string | undefined;
    integrationJobLogStatusChangeRecipients?: string | undefined;
    integrationJobGroupStatusChangeCCRecipients?: string | undefined;
    integrationJobLogStatusChangeCCRecipients?: string | undefined;
    getBulkWriteoffsPageSize?: number;
    lateTimeThreshold?: number;
    disassociateButtonRoles?: string[] | undefined;
    careAttendDocumentTypes?: string[] | undefined;
    v4FaqSiteURL?: string | undefined;
    createEORPersonDefault?: boolean;
    defaultArea?: string | undefined;
    injectorLimit?: number;
    preciseDeductionTypes?: string[] | undefined;
    dailyWorkLimit?: number | undefined;
    rolesEligibleForShiftComments?: string[] | undefined;
    shiftCommentsLabel?: { [key: string]: string; } | undefined;
    shiftCommentsTitle?: { [key: string]: string; } | undefined;
    exclusionaryServiceConfig?: { [key: string]: string[]; } | undefined;
    rolesEligibleToViewTasksOnShiftSummary?: string[] | undefined;
    rolesEligibleToViewCommentsOnShiftSummary?: string[] | undefined;
    shiftSummaryCommentsTitle?: { [key: string]: string; } | undefined;
    startOfTheWeek?: string | undefined;
    taskConfigurationType?: string | undefined;
    stateCode?: string | undefined;
    searchDaysDifference?: number;
    relationshipWWL?: { [key: string]: number; } | undefined;
    solomonAdminShiftConfiguration?: SolomonAdminShiftConfiguration;
    testServiceCodeCommentsRequired?: string | undefined;
    dmcmAlternativeLabels?: { [key: string]: string; } | undefined;
    internalUseServiceCodes?: string[] | undefined;
    reminderNotification?: ReminderNotificationConfiguration;
    dmcmPersonTypes?: string[] | undefined;
    placeOfServiceOptions?: number[] | undefined;
    validationOverrideEnabled?: boolean;

    constructor(data?: ICompanyConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initialExternalShiftStatus = _data["initialExternalShiftStatus"];
            this.wwlDefault = _data["wwlDefault"];
            this.defaultPTOServiceCode = _data["defaultPTOServiceCode"];
            this.glUnappliedPaymentProgramWorkTag = _data["glUnappliedPaymentProgramWorkTag"];
            this.testServiceCode = _data["testServiceCode"];
            this.defaultTestAuthEndDateOffset = _data["defaultTestAuthEndDateOffset"];
            this.otFrequencyHours = _data["otFrequencyHours"];
            this.cellTrakDelayedHours = _data["cellTrakDelayedHours"];
            this.weekStartDay = _data["weekStartDay"];
            this.weekEndDay = _data["weekEndDay"];
            this.wwlTemporaryLessThanPermanentAllowed = _data["wwlTemporaryLessThanPermanentAllowed"];
            this.timeZone = _data["timeZone"] ? TimeZoneConfig.fromJS(_data["timeZone"]) : <any>undefined;
            this.liveInModifier = _data["liveInModifier"];
            this.defaultEmployer = _data["defaultEmployer"] ? DefaultEmployer.fromJS(_data["defaultEmployer"]) : <any>undefined;
            this.defaultPayor = _data["defaultPayor"];
            this.cdwaPhoneNumber = _data["cdwaPhoneNumber"];
            this.bccuPhoneNumber = _data["bccuPhoneNumber"];
            this.dshsPhoneNumber = _data["dshsPhoneNumber"];
            this.mrcPhoneNumber = _data["mrcPhoneNumber"];
            if (_data["contactPhoneNumbers"]) {
                this.contactPhoneNumbers = {} as any;
                for (let key in _data["contactPhoneNumbers"]) {
                    if (_data["contactPhoneNumbers"].hasOwnProperty(key))
                        (<any>this.contactPhoneNumbers)![key] = _data["contactPhoneNumbers"][key];
                }
            }
            if (_data["contactAddress"]) {
                this.contactAddress = {} as any;
                for (let key in _data["contactAddress"]) {
                    if (_data["contactAddress"].hasOwnProperty(key))
                        (<any>this.contactAddress)![key] = _data["contactAddress"][key];
                }
            }
            this.relationshipAttestationPhoneNumber = _data["relationshipAttestationPhoneNumber"];
            this.attestationVersion = _data["attestationVersion"];
            this.docAttestationVersion = _data["docAttestationVersion"];
            this.ficaAttestationVersion = _data["ficaAttestationVersion"];
            this.leAttestationVersion = _data["leAttestationVersion"];
            if (Array.isArray(_data["requiredAttestationTypes"])) {
                this.requiredAttestationTypes = [] as any;
                for (let item of _data["requiredAttestationTypes"])
                    this.requiredAttestationTypes!.push(item);
            }
            this.v4AdditionalRelationshipDisplayDays = _data["v4AdditionalRelationshipDisplayDays"];
            this.mileageServiceCodes = _data["mileageServiceCodes"] ? MileageServiceCodes.fromJS(_data["mileageServiceCodes"]) : <any>undefined;
            if (_data["additionalConfigs"]) {
                this.additionalConfigs = {} as any;
                for (let key in _data["additionalConfigs"]) {
                    if (_data["additionalConfigs"].hasOwnProperty(key))
                        (<any>this.additionalConfigs)![key] = _data["additionalConfigs"][key];
                }
            }
            if (_data["personTypeConfiguration"]) {
                this.personTypeConfiguration = {} as any;
                for (let key in _data["personTypeConfiguration"]) {
                    if (_data["personTypeConfiguration"].hasOwnProperty(key))
                        (<any>this.personTypeConfiguration)![key] = _data["personTypeConfiguration"][key] ? PersonTypeConfiguration.fromJS(_data["personTypeConfiguration"][key]) : new PersonTypeConfiguration();
                }
            }
            this.gracePeriodConfiguration = _data["gracePeriodConfiguration"] ? GracePeriodConfiguration.fromJS(_data["gracePeriodConfiguration"]) : <any>undefined;
            this.weeklyOvertimeCutoff = _data["weeklyOvertimeCutoff"];
            this.dailyOvertimeCutoff = _data["dailyOvertimeCutoff"];
            this.overtimeMultiplier = _data["overtimeMultiplier"];
            this.holidayMultiplier = _data["holidayMultiplier"];
            this.payStubExternalUrl = _data["payStubExternalUrl"];
            this.accountNotificationEmail = _data["accountNotificationEmail"];
            this.cosmosCollection = _data["cosmosCollection"];
            if (Array.isArray(_data["autoAdminTimeExemptServiceCodes"])) {
                this.autoAdminTimeExemptServiceCodes = [] as any;
                for (let item of _data["autoAdminTimeExemptServiceCodes"])
                    this.autoAdminTimeExemptServiceCodes!.push(item);
            }
            this.authExpirationGracePeriodDays = _data["authExpirationGracePeriodDays"];
            this.adjustCchBatchSize = _data["adjustCchBatchSize"];
            this.persistPayrollBatchSize = _data["persistPayrollBatchSize"];
            this.updateBillingBatchSize = _data["updateBillingBatchSize"];
            this.updateCareerBatchSize = _data["updateCareerBatchSize"];
            this.updateHolidayBatchSize = _data["updateHolidayBatchSize"];
            this.defaultAddress = _data["defaultAddress"] ? AddressConfig.fromJS(_data["defaultAddress"]) : <any>undefined;
            this.outsideGeofenceAddress = _data["outsideGeofenceAddress"] ? AddressConfig.fromJS(_data["outsideGeofenceAddress"]) : <any>undefined;
            this.geofenceDistanceFeet = _data["geofenceDistanceFeet"];
            this.backoffTime = _data["backoffTime"];
            this.maxAdjustmentBatchSize = _data["maxAdjustmentBatchSize"];
            this.maxSyncTime = _data["maxSyncTime"];
            this.maxSyncBatchSize = _data["maxSyncBatchSize"];
            this.staticIvrPin = _data["staticIvrPin"];
            if (Array.isArray(_data["excludedHcpcsBillCodes"])) {
                this.excludedHcpcsBillCodes = [] as any;
                for (let item of _data["excludedHcpcsBillCodes"])
                    this.excludedHcpcsBillCodes!.push(item);
            }
            this.maxAutoAdminSyncTimeInMinutes = _data["maxAutoAdminSyncTimeInMinutes"];
            if (Array.isArray(_data["requiredExternalMappingIds"])) {
                this.requiredExternalMappingIds = [] as any;
                for (let item of _data["requiredExternalMappingIds"])
                    this.requiredExternalMappingIds!.push(item);
            }
            this.timeShiftDocTypeThresholds = _data["timeShiftDocTypeThresholds"] ? ThresholdRulesConfig.fromJS(_data["timeShiftDocTypeThresholds"]) : <any>undefined;
            this.feeDocTypeThresholds = _data["feeDocTypeThresholds"] ? ThresholdRulesConfig.fromJS(_data["feeDocTypeThresholds"]) : <any>undefined;
            this.mileageDocTypeThresholds = _data["mileageDocTypeThresholds"] ? ThresholdRulesConfig.fromJS(_data["mileageDocTypeThresholds"]) : <any>undefined;
            this.ghsDocTypeThresholds = _data["ghsDocTypeThresholds"] ? ThresholdRulesConfig.fromJS(_data["ghsDocTypeThresholds"]) : <any>undefined;
            this.ghaDocTypeThresholds = _data["ghaDocTypeThresholds"] ? ThresholdRulesConfig.fromJS(_data["ghaDocTypeThresholds"]) : <any>undefined;
            this.paymentJsonFolderName = _data["paymentJsonFolderName"];
            this.blobStorageContainerName = _data["blobStorageContainerName"];
            this.emptyBlobName = _data["emptyBlobName"];
            if (Array.isArray(_data["notificationRecipients"])) {
                this.notificationRecipients = [] as any;
                for (let item of _data["notificationRecipients"])
                    this.notificationRecipients!.push(item);
            }
            if (Array.isArray(_data["allowedDomainEvents"])) {
                this.allowedDomainEvents = [] as any;
                for (let item of _data["allowedDomainEvents"])
                    this.allowedDomainEvents!.push(item);
            }
            if (Array.isArray(_data["serviceDateEvents"])) {
                this.serviceDateEvents = [] as any;
                for (let item of _data["serviceDateEvents"])
                    this.serviceDateEvents!.push(item);
            }
            if (Array.isArray(_data["b2COnboardingEmailNotificationPersonTypes"])) {
                this.b2COnboardingEmailNotificationPersonTypes = [] as any;
                for (let item of _data["b2COnboardingEmailNotificationPersonTypes"])
                    this.b2COnboardingEmailNotificationPersonTypes!.push(item);
            }
            if (Array.isArray(_data["b2CEmailUpdateEmailNotificationPersonTypes"])) {
                this.b2CEmailUpdateEmailNotificationPersonTypes = [] as any;
                for (let item of _data["b2CEmailUpdateEmailNotificationPersonTypes"])
                    this.b2CEmailUpdateEmailNotificationPersonTypes!.push(item);
            }
            if (Array.isArray(_data["b2COnboardingPersonTypes"])) {
                this.b2COnboardingPersonTypes = [] as any;
                for (let item of _data["b2COnboardingPersonTypes"])
                    this.b2COnboardingPersonTypes!.push(item);
            }
            if (Array.isArray(_data["b2CEmailUpdatePersonTypes"])) {
                this.b2CEmailUpdatePersonTypes = [] as any;
                for (let item of _data["b2CEmailUpdatePersonTypes"])
                    this.b2CEmailUpdatePersonTypes!.push(item);
            }
            if (Array.isArray(_data["ssnValidationPersonTypes"])) {
                this.ssnValidationPersonTypes = [] as any;
                for (let item of _data["ssnValidationPersonTypes"])
                    this.ssnValidationPersonTypes!.push(item);
            }
            if (Array.isArray(_data["activeTestShiftRoles"])) {
                this.activeTestShiftRoles = [] as any;
                for (let item of _data["activeTestShiftRoles"])
                    this.activeTestShiftRoles!.push(item);
            }
            if (Array.isArray(_data["serviceCutoffConfiguration"])) {
                this.serviceCutoffConfiguration = [] as any;
                for (let item of _data["serviceCutoffConfiguration"])
                    this.serviceCutoffConfiguration!.push(PayorServiceCutoff.fromJS(item));
            }
            if (_data["ssnValidationSuccess"]) {
                this.ssnValidationSuccess = {} as any;
                for (let key in _data["ssnValidationSuccess"]) {
                    if (_data["ssnValidationSuccess"].hasOwnProperty(key))
                        (<any>this.ssnValidationSuccess)![key] = _data["ssnValidationSuccess"][key];
                }
            }
            if (Array.isArray(_data["ssnValidationOverridePersonTypes"])) {
                this.ssnValidationOverridePersonTypes = [] as any;
                for (let item of _data["ssnValidationOverridePersonTypes"])
                    this.ssnValidationOverridePersonTypes!.push(item);
            }
            this.ssnValidationFailureContactNumber = _data["ssnValidationFailureContactNumber"];
            this.integrationJobSenderUserName = _data["integrationJobSenderUserName"];
            this.integrationJobSenderEmail = _data["integrationJobSenderEmail"];
            this.integrationJobGroupStatusChangeRecipients = _data["integrationJobGroupStatusChangeRecipients"];
            this.integrationJobLogStatusChangeRecipients = _data["integrationJobLogStatusChangeRecipients"];
            this.integrationJobGroupStatusChangeCCRecipients = _data["integrationJobGroupStatusChangeCCRecipients"];
            this.integrationJobLogStatusChangeCCRecipients = _data["integrationJobLogStatusChangeCCRecipients"];
            this.getBulkWriteoffsPageSize = _data["getBulkWriteoffsPageSize"];
            this.lateTimeThreshold = _data["lateTimeThreshold"];
            if (Array.isArray(_data["disassociateButtonRoles"])) {
                this.disassociateButtonRoles = [] as any;
                for (let item of _data["disassociateButtonRoles"])
                    this.disassociateButtonRoles!.push(item);
            }
            if (Array.isArray(_data["careAttendDocumentTypes"])) {
                this.careAttendDocumentTypes = [] as any;
                for (let item of _data["careAttendDocumentTypes"])
                    this.careAttendDocumentTypes!.push(item);
            }
            this.v4FaqSiteURL = _data["v4FaqSiteURL"];
            this.createEORPersonDefault = _data["createEORPersonDefault"];
            this.defaultArea = _data["defaultArea"];
            this.injectorLimit = _data["injectorLimit"];
            if (Array.isArray(_data["preciseDeductionTypes"])) {
                this.preciseDeductionTypes = [] as any;
                for (let item of _data["preciseDeductionTypes"])
                    this.preciseDeductionTypes!.push(item);
            }
            this.dailyWorkLimit = _data["dailyWorkLimit"];
            if (Array.isArray(_data["rolesEligibleForShiftComments"])) {
                this.rolesEligibleForShiftComments = [] as any;
                for (let item of _data["rolesEligibleForShiftComments"])
                    this.rolesEligibleForShiftComments!.push(item);
            }
            if (_data["shiftCommentsLabel"]) {
                this.shiftCommentsLabel = {} as any;
                for (let key in _data["shiftCommentsLabel"]) {
                    if (_data["shiftCommentsLabel"].hasOwnProperty(key))
                        (<any>this.shiftCommentsLabel)![key] = _data["shiftCommentsLabel"][key];
                }
            }
            if (_data["shiftCommentsTitle"]) {
                this.shiftCommentsTitle = {} as any;
                for (let key in _data["shiftCommentsTitle"]) {
                    if (_data["shiftCommentsTitle"].hasOwnProperty(key))
                        (<any>this.shiftCommentsTitle)![key] = _data["shiftCommentsTitle"][key];
                }
            }
            if (_data["exclusionaryServiceConfig"]) {
                this.exclusionaryServiceConfig = {} as any;
                for (let key in _data["exclusionaryServiceConfig"]) {
                    if (_data["exclusionaryServiceConfig"].hasOwnProperty(key))
                        (<any>this.exclusionaryServiceConfig)![key] = _data["exclusionaryServiceConfig"][key] !== undefined ? _data["exclusionaryServiceConfig"][key] : [];
                }
            }
            if (Array.isArray(_data["rolesEligibleToViewTasksOnShiftSummary"])) {
                this.rolesEligibleToViewTasksOnShiftSummary = [] as any;
                for (let item of _data["rolesEligibleToViewTasksOnShiftSummary"])
                    this.rolesEligibleToViewTasksOnShiftSummary!.push(item);
            }
            if (Array.isArray(_data["rolesEligibleToViewCommentsOnShiftSummary"])) {
                this.rolesEligibleToViewCommentsOnShiftSummary = [] as any;
                for (let item of _data["rolesEligibleToViewCommentsOnShiftSummary"])
                    this.rolesEligibleToViewCommentsOnShiftSummary!.push(item);
            }
            if (_data["shiftSummaryCommentsTitle"]) {
                this.shiftSummaryCommentsTitle = {} as any;
                for (let key in _data["shiftSummaryCommentsTitle"]) {
                    if (_data["shiftSummaryCommentsTitle"].hasOwnProperty(key))
                        (<any>this.shiftSummaryCommentsTitle)![key] = _data["shiftSummaryCommentsTitle"][key];
                }
            }
            this.startOfTheWeek = _data["startOfTheWeek"];
            this.taskConfigurationType = _data["taskConfigurationType"];
            this.stateCode = _data["stateCode"];
            this.searchDaysDifference = _data["searchDaysDifference"];
            if (_data["relationshipWWL"]) {
                this.relationshipWWL = {} as any;
                for (let key in _data["relationshipWWL"]) {
                    if (_data["relationshipWWL"].hasOwnProperty(key))
                        (<any>this.relationshipWWL)![key] = _data["relationshipWWL"][key];
                }
            }
            this.solomonAdminShiftConfiguration = _data["solomonAdminShiftConfiguration"] ? SolomonAdminShiftConfiguration.fromJS(_data["solomonAdminShiftConfiguration"]) : <any>undefined;
            this.testServiceCodeCommentsRequired = _data["testServiceCodeCommentsRequired"];
            if (_data["dmcmAlternativeLabels"]) {
                this.dmcmAlternativeLabels = {} as any;
                for (let key in _data["dmcmAlternativeLabels"]) {
                    if (_data["dmcmAlternativeLabels"].hasOwnProperty(key))
                        (<any>this.dmcmAlternativeLabels)![key] = _data["dmcmAlternativeLabels"][key];
                }
            }
            if (Array.isArray(_data["internalUseServiceCodes"])) {
                this.internalUseServiceCodes = [] as any;
                for (let item of _data["internalUseServiceCodes"])
                    this.internalUseServiceCodes!.push(item);
            }
            this.reminderNotification = _data["reminderNotification"] ? ReminderNotificationConfiguration.fromJS(_data["reminderNotification"]) : <any>undefined;
            if (Array.isArray(_data["dmcmPersonTypes"])) {
                this.dmcmPersonTypes = [] as any;
                for (let item of _data["dmcmPersonTypes"])
                    this.dmcmPersonTypes!.push(item);
            }
            if (Array.isArray(_data["placeOfServiceOptions"])) {
                this.placeOfServiceOptions = [] as any;
                for (let item of _data["placeOfServiceOptions"])
                    this.placeOfServiceOptions!.push(item);
            }
            this.validationOverrideEnabled = _data["validationOverrideEnabled"];
        }
    }

    static fromJS(data: any): CompanyConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initialExternalShiftStatus"] = this.initialExternalShiftStatus;
        data["wwlDefault"] = this.wwlDefault;
        data["defaultPTOServiceCode"] = this.defaultPTOServiceCode;
        data["glUnappliedPaymentProgramWorkTag"] = this.glUnappliedPaymentProgramWorkTag;
        data["testServiceCode"] = this.testServiceCode;
        data["defaultTestAuthEndDateOffset"] = this.defaultTestAuthEndDateOffset;
        data["otFrequencyHours"] = this.otFrequencyHours;
        data["cellTrakDelayedHours"] = this.cellTrakDelayedHours;
        data["weekStartDay"] = this.weekStartDay;
        data["weekEndDay"] = this.weekEndDay;
        data["wwlTemporaryLessThanPermanentAllowed"] = this.wwlTemporaryLessThanPermanentAllowed;
        data["timeZone"] = this.timeZone ? this.timeZone.toJSON() : <any>undefined;
        data["liveInModifier"] = this.liveInModifier;
        data["defaultEmployer"] = this.defaultEmployer ? this.defaultEmployer.toJSON() : <any>undefined;
        data["defaultPayor"] = this.defaultPayor;
        data["cdwaPhoneNumber"] = this.cdwaPhoneNumber;
        data["bccuPhoneNumber"] = this.bccuPhoneNumber;
        data["dshsPhoneNumber"] = this.dshsPhoneNumber;
        data["mrcPhoneNumber"] = this.mrcPhoneNumber;
        if (this.contactPhoneNumbers) {
            data["contactPhoneNumbers"] = {};
            for (let key in this.contactPhoneNumbers) {
                if (this.contactPhoneNumbers.hasOwnProperty(key))
                    (<any>data["contactPhoneNumbers"])[key] = (<any>this.contactPhoneNumbers)[key];
            }
        }
        if (this.contactAddress) {
            data["contactAddress"] = {};
            for (let key in this.contactAddress) {
                if (this.contactAddress.hasOwnProperty(key))
                    (<any>data["contactAddress"])[key] = (<any>this.contactAddress)[key];
            }
        }
        data["relationshipAttestationPhoneNumber"] = this.relationshipAttestationPhoneNumber;
        data["attestationVersion"] = this.attestationVersion;
        data["docAttestationVersion"] = this.docAttestationVersion;
        data["ficaAttestationVersion"] = this.ficaAttestationVersion;
        data["leAttestationVersion"] = this.leAttestationVersion;
        if (Array.isArray(this.requiredAttestationTypes)) {
            data["requiredAttestationTypes"] = [];
            for (let item of this.requiredAttestationTypes)
                data["requiredAttestationTypes"].push(item);
        }
        data["v4AdditionalRelationshipDisplayDays"] = this.v4AdditionalRelationshipDisplayDays;
        data["mileageServiceCodes"] = this.mileageServiceCodes ? this.mileageServiceCodes.toJSON() : <any>undefined;
        if (this.additionalConfigs) {
            data["additionalConfigs"] = {};
            for (let key in this.additionalConfigs) {
                if (this.additionalConfigs.hasOwnProperty(key))
                    (<any>data["additionalConfigs"])[key] = (<any>this.additionalConfigs)[key];
            }
        }
        if (this.personTypeConfiguration) {
            data["personTypeConfiguration"] = {};
            for (let key in this.personTypeConfiguration) {
                if (this.personTypeConfiguration.hasOwnProperty(key))
                    (<any>data["personTypeConfiguration"])[key] = this.personTypeConfiguration[key] ? this.personTypeConfiguration[key].toJSON() : <any>undefined;
            }
        }
        data["gracePeriodConfiguration"] = this.gracePeriodConfiguration ? this.gracePeriodConfiguration.toJSON() : <any>undefined;
        data["weeklyOvertimeCutoff"] = this.weeklyOvertimeCutoff;
        data["dailyOvertimeCutoff"] = this.dailyOvertimeCutoff;
        data["overtimeMultiplier"] = this.overtimeMultiplier;
        data["holidayMultiplier"] = this.holidayMultiplier;
        data["payStubExternalUrl"] = this.payStubExternalUrl;
        data["accountNotificationEmail"] = this.accountNotificationEmail;
        data["cosmosCollection"] = this.cosmosCollection;
        if (Array.isArray(this.autoAdminTimeExemptServiceCodes)) {
            data["autoAdminTimeExemptServiceCodes"] = [];
            for (let item of this.autoAdminTimeExemptServiceCodes)
                data["autoAdminTimeExemptServiceCodes"].push(item);
        }
        data["authExpirationGracePeriodDays"] = this.authExpirationGracePeriodDays;
        data["adjustCchBatchSize"] = this.adjustCchBatchSize;
        data["persistPayrollBatchSize"] = this.persistPayrollBatchSize;
        data["updateBillingBatchSize"] = this.updateBillingBatchSize;
        data["updateCareerBatchSize"] = this.updateCareerBatchSize;
        data["updateHolidayBatchSize"] = this.updateHolidayBatchSize;
        data["defaultAddress"] = this.defaultAddress ? this.defaultAddress.toJSON() : <any>undefined;
        data["outsideGeofenceAddress"] = this.outsideGeofenceAddress ? this.outsideGeofenceAddress.toJSON() : <any>undefined;
        data["geofenceDistanceFeet"] = this.geofenceDistanceFeet;
        data["backoffTime"] = this.backoffTime;
        data["maxAdjustmentBatchSize"] = this.maxAdjustmentBatchSize;
        data["maxSyncTime"] = this.maxSyncTime;
        data["maxSyncBatchSize"] = this.maxSyncBatchSize;
        data["staticIvrPin"] = this.staticIvrPin;
        if (Array.isArray(this.excludedHcpcsBillCodes)) {
            data["excludedHcpcsBillCodes"] = [];
            for (let item of this.excludedHcpcsBillCodes)
                data["excludedHcpcsBillCodes"].push(item);
        }
        data["maxAutoAdminSyncTimeInMinutes"] = this.maxAutoAdminSyncTimeInMinutes;
        if (Array.isArray(this.requiredExternalMappingIds)) {
            data["requiredExternalMappingIds"] = [];
            for (let item of this.requiredExternalMappingIds)
                data["requiredExternalMappingIds"].push(item);
        }
        data["timeShiftDocTypeThresholds"] = this.timeShiftDocTypeThresholds ? this.timeShiftDocTypeThresholds.toJSON() : <any>undefined;
        data["feeDocTypeThresholds"] = this.feeDocTypeThresholds ? this.feeDocTypeThresholds.toJSON() : <any>undefined;
        data["mileageDocTypeThresholds"] = this.mileageDocTypeThresholds ? this.mileageDocTypeThresholds.toJSON() : <any>undefined;
        data["ghsDocTypeThresholds"] = this.ghsDocTypeThresholds ? this.ghsDocTypeThresholds.toJSON() : <any>undefined;
        data["ghaDocTypeThresholds"] = this.ghaDocTypeThresholds ? this.ghaDocTypeThresholds.toJSON() : <any>undefined;
        data["paymentJsonFolderName"] = this.paymentJsonFolderName;
        data["blobStorageContainerName"] = this.blobStorageContainerName;
        data["emptyBlobName"] = this.emptyBlobName;
        if (Array.isArray(this.notificationRecipients)) {
            data["notificationRecipients"] = [];
            for (let item of this.notificationRecipients)
                data["notificationRecipients"].push(item);
        }
        if (Array.isArray(this.allowedDomainEvents)) {
            data["allowedDomainEvents"] = [];
            for (let item of this.allowedDomainEvents)
                data["allowedDomainEvents"].push(item);
        }
        if (Array.isArray(this.serviceDateEvents)) {
            data["serviceDateEvents"] = [];
            for (let item of this.serviceDateEvents)
                data["serviceDateEvents"].push(item);
        }
        if (Array.isArray(this.b2COnboardingEmailNotificationPersonTypes)) {
            data["b2COnboardingEmailNotificationPersonTypes"] = [];
            for (let item of this.b2COnboardingEmailNotificationPersonTypes)
                data["b2COnboardingEmailNotificationPersonTypes"].push(item);
        }
        if (Array.isArray(this.b2CEmailUpdateEmailNotificationPersonTypes)) {
            data["b2CEmailUpdateEmailNotificationPersonTypes"] = [];
            for (let item of this.b2CEmailUpdateEmailNotificationPersonTypes)
                data["b2CEmailUpdateEmailNotificationPersonTypes"].push(item);
        }
        if (Array.isArray(this.b2COnboardingPersonTypes)) {
            data["b2COnboardingPersonTypes"] = [];
            for (let item of this.b2COnboardingPersonTypes)
                data["b2COnboardingPersonTypes"].push(item);
        }
        if (Array.isArray(this.b2CEmailUpdatePersonTypes)) {
            data["b2CEmailUpdatePersonTypes"] = [];
            for (let item of this.b2CEmailUpdatePersonTypes)
                data["b2CEmailUpdatePersonTypes"].push(item);
        }
        if (Array.isArray(this.ssnValidationPersonTypes)) {
            data["ssnValidationPersonTypes"] = [];
            for (let item of this.ssnValidationPersonTypes)
                data["ssnValidationPersonTypes"].push(item);
        }
        if (Array.isArray(this.activeTestShiftRoles)) {
            data["activeTestShiftRoles"] = [];
            for (let item of this.activeTestShiftRoles)
                data["activeTestShiftRoles"].push(item);
        }
        if (Array.isArray(this.serviceCutoffConfiguration)) {
            data["serviceCutoffConfiguration"] = [];
            for (let item of this.serviceCutoffConfiguration)
                data["serviceCutoffConfiguration"].push(item ? item.toJSON() : <any>undefined);
        }
        if (this.ssnValidationSuccess) {
            data["ssnValidationSuccess"] = {};
            for (let key in this.ssnValidationSuccess) {
                if (this.ssnValidationSuccess.hasOwnProperty(key))
                    (<any>data["ssnValidationSuccess"])[key] = (<any>this.ssnValidationSuccess)[key];
            }
        }
        if (Array.isArray(this.ssnValidationOverridePersonTypes)) {
            data["ssnValidationOverridePersonTypes"] = [];
            for (let item of this.ssnValidationOverridePersonTypes)
                data["ssnValidationOverridePersonTypes"].push(item);
        }
        data["ssnValidationFailureContactNumber"] = this.ssnValidationFailureContactNumber;
        data["integrationJobSenderUserName"] = this.integrationJobSenderUserName;
        data["integrationJobSenderEmail"] = this.integrationJobSenderEmail;
        data["integrationJobGroupStatusChangeRecipients"] = this.integrationJobGroupStatusChangeRecipients;
        data["integrationJobLogStatusChangeRecipients"] = this.integrationJobLogStatusChangeRecipients;
        data["integrationJobGroupStatusChangeCCRecipients"] = this.integrationJobGroupStatusChangeCCRecipients;
        data["integrationJobLogStatusChangeCCRecipients"] = this.integrationJobLogStatusChangeCCRecipients;
        data["getBulkWriteoffsPageSize"] = this.getBulkWriteoffsPageSize;
        data["lateTimeThreshold"] = this.lateTimeThreshold;
        if (Array.isArray(this.disassociateButtonRoles)) {
            data["disassociateButtonRoles"] = [];
            for (let item of this.disassociateButtonRoles)
                data["disassociateButtonRoles"].push(item);
        }
        if (Array.isArray(this.careAttendDocumentTypes)) {
            data["careAttendDocumentTypes"] = [];
            for (let item of this.careAttendDocumentTypes)
                data["careAttendDocumentTypes"].push(item);
        }
        data["v4FaqSiteURL"] = this.v4FaqSiteURL;
        data["createEORPersonDefault"] = this.createEORPersonDefault;
        data["defaultArea"] = this.defaultArea;
        data["injectorLimit"] = this.injectorLimit;
        if (Array.isArray(this.preciseDeductionTypes)) {
            data["preciseDeductionTypes"] = [];
            for (let item of this.preciseDeductionTypes)
                data["preciseDeductionTypes"].push(item);
        }
        data["dailyWorkLimit"] = this.dailyWorkLimit;
        if (Array.isArray(this.rolesEligibleForShiftComments)) {
            data["rolesEligibleForShiftComments"] = [];
            for (let item of this.rolesEligibleForShiftComments)
                data["rolesEligibleForShiftComments"].push(item);
        }
        if (this.shiftCommentsLabel) {
            data["shiftCommentsLabel"] = {};
            for (let key in this.shiftCommentsLabel) {
                if (this.shiftCommentsLabel.hasOwnProperty(key))
                    (<any>data["shiftCommentsLabel"])[key] = (<any>this.shiftCommentsLabel)[key];
            }
        }
        if (this.shiftCommentsTitle) {
            data["shiftCommentsTitle"] = {};
            for (let key in this.shiftCommentsTitle) {
                if (this.shiftCommentsTitle.hasOwnProperty(key))
                    (<any>data["shiftCommentsTitle"])[key] = (<any>this.shiftCommentsTitle)[key];
            }
        }
        if (this.exclusionaryServiceConfig) {
            data["exclusionaryServiceConfig"] = {};
            for (let key in this.exclusionaryServiceConfig) {
                if (this.exclusionaryServiceConfig.hasOwnProperty(key))
                    (<any>data["exclusionaryServiceConfig"])[key] = (<any>this.exclusionaryServiceConfig)[key];
            }
        }
        if (Array.isArray(this.rolesEligibleToViewTasksOnShiftSummary)) {
            data["rolesEligibleToViewTasksOnShiftSummary"] = [];
            for (let item of this.rolesEligibleToViewTasksOnShiftSummary)
                data["rolesEligibleToViewTasksOnShiftSummary"].push(item);
        }
        if (Array.isArray(this.rolesEligibleToViewCommentsOnShiftSummary)) {
            data["rolesEligibleToViewCommentsOnShiftSummary"] = [];
            for (let item of this.rolesEligibleToViewCommentsOnShiftSummary)
                data["rolesEligibleToViewCommentsOnShiftSummary"].push(item);
        }
        if (this.shiftSummaryCommentsTitle) {
            data["shiftSummaryCommentsTitle"] = {};
            for (let key in this.shiftSummaryCommentsTitle) {
                if (this.shiftSummaryCommentsTitle.hasOwnProperty(key))
                    (<any>data["shiftSummaryCommentsTitle"])[key] = (<any>this.shiftSummaryCommentsTitle)[key];
            }
        }
        data["startOfTheWeek"] = this.startOfTheWeek;
        data["taskConfigurationType"] = this.taskConfigurationType;
        data["stateCode"] = this.stateCode;
        data["searchDaysDifference"] = this.searchDaysDifference;
        if (this.relationshipWWL) {
            data["relationshipWWL"] = {};
            for (let key in this.relationshipWWL) {
                if (this.relationshipWWL.hasOwnProperty(key))
                    (<any>data["relationshipWWL"])[key] = (<any>this.relationshipWWL)[key];
            }
        }
        data["solomonAdminShiftConfiguration"] = this.solomonAdminShiftConfiguration ? this.solomonAdminShiftConfiguration.toJSON() : <any>undefined;
        data["testServiceCodeCommentsRequired"] = this.testServiceCodeCommentsRequired;
        if (this.dmcmAlternativeLabels) {
            data["dmcmAlternativeLabels"] = {};
            for (let key in this.dmcmAlternativeLabels) {
                if (this.dmcmAlternativeLabels.hasOwnProperty(key))
                    (<any>data["dmcmAlternativeLabels"])[key] = (<any>this.dmcmAlternativeLabels)[key];
            }
        }
        if (Array.isArray(this.internalUseServiceCodes)) {
            data["internalUseServiceCodes"] = [];
            for (let item of this.internalUseServiceCodes)
                data["internalUseServiceCodes"].push(item);
        }
        data["reminderNotification"] = this.reminderNotification ? this.reminderNotification.toJSON() : <any>undefined;
        if (Array.isArray(this.dmcmPersonTypes)) {
            data["dmcmPersonTypes"] = [];
            for (let item of this.dmcmPersonTypes)
                data["dmcmPersonTypes"].push(item);
        }
        if (Array.isArray(this.placeOfServiceOptions)) {
            data["placeOfServiceOptions"] = [];
            for (let item of this.placeOfServiceOptions)
                data["placeOfServiceOptions"].push(item);
        }
        data["validationOverrideEnabled"] = this.validationOverrideEnabled;
        return data;
    }
}

export interface ICompanyConfiguration {
    initialExternalShiftStatus?: number;
    wwlDefault?: number;
    defaultPTOServiceCode?: string | undefined;
    glUnappliedPaymentProgramWorkTag?: string | undefined;
    testServiceCode?: string | undefined;
    defaultTestAuthEndDateOffset?: number;
    otFrequencyHours?: number;
    cellTrakDelayedHours?: number;
    weekStartDay?: string | undefined;
    weekEndDay?: string | undefined;
    wwlTemporaryLessThanPermanentAllowed?: boolean;
    timeZone?: TimeZoneConfig;
    liveInModifier?: string | undefined;
    defaultEmployer?: DefaultEmployer;
    defaultPayor?: string | undefined;
    cdwaPhoneNumber?: string | undefined;
    bccuPhoneNumber?: string | undefined;
    dshsPhoneNumber?: string | undefined;
    mrcPhoneNumber?: string | undefined;
    contactPhoneNumbers?: { [key: string]: string; } | undefined;
    contactAddress?: { [key: string]: string; } | undefined;
    relationshipAttestationPhoneNumber?: string | undefined;
    attestationVersion?: number;
    docAttestationVersion?: number;
    ficaAttestationVersion?: number;
    leAttestationVersion?: number;
    requiredAttestationTypes?: string[] | undefined;
    v4AdditionalRelationshipDisplayDays?: number;
    mileageServiceCodes?: MileageServiceCodes;
    additionalConfigs?: { [key: string]: any; } | undefined;
    personTypeConfiguration?: { [key: string]: PersonTypeConfiguration; } | undefined;
    gracePeriodConfiguration?: GracePeriodConfiguration;
    weeklyOvertimeCutoff?: number;
    dailyOvertimeCutoff?: number;
    overtimeMultiplier?: number;
    holidayMultiplier?: number;
    payStubExternalUrl?: string | undefined;
    accountNotificationEmail?: string | undefined;
    cosmosCollection?: string | undefined;
    autoAdminTimeExemptServiceCodes?: string[] | undefined;
    authExpirationGracePeriodDays?: number;
    adjustCchBatchSize?: number;
    persistPayrollBatchSize?: number;
    updateBillingBatchSize?: number;
    updateCareerBatchSize?: number;
    updateHolidayBatchSize?: number;
    defaultAddress?: AddressConfig;
    outsideGeofenceAddress?: AddressConfig;
    geofenceDistanceFeet?: number;
    backoffTime?: number;
    maxAdjustmentBatchSize?: number;
    maxSyncTime?: number;
    maxSyncBatchSize?: number;
    staticIvrPin?: string | undefined;
    excludedHcpcsBillCodes?: string[] | undefined;
    maxAutoAdminSyncTimeInMinutes?: number | undefined;
    requiredExternalMappingIds?: string[] | undefined;
    timeShiftDocTypeThresholds?: ThresholdRulesConfig;
    feeDocTypeThresholds?: ThresholdRulesConfig;
    mileageDocTypeThresholds?: ThresholdRulesConfig;
    ghsDocTypeThresholds?: ThresholdRulesConfig;
    ghaDocTypeThresholds?: ThresholdRulesConfig;
    paymentJsonFolderName?: string | undefined;
    blobStorageContainerName?: string | undefined;
    emptyBlobName?: string | undefined;
    notificationRecipients?: string[] | undefined;
    allowedDomainEvents?: string[] | undefined;
    serviceDateEvents?: string[] | undefined;
    b2COnboardingEmailNotificationPersonTypes?: string[] | undefined;
    b2CEmailUpdateEmailNotificationPersonTypes?: string[] | undefined;
    b2COnboardingPersonTypes?: string[] | undefined;
    b2CEmailUpdatePersonTypes?: string[] | undefined;
    ssnValidationPersonTypes?: string[] | undefined;
    activeTestShiftRoles?: string[] | undefined;
    serviceCutoffConfiguration?: PayorServiceCutoff[] | undefined;
    ssnValidationSuccess?: { [key: string]: string; } | undefined;
    ssnValidationOverridePersonTypes?: string[] | undefined;
    ssnValidationFailureContactNumber?: string | undefined;
    integrationJobSenderUserName?: string | undefined;
    integrationJobSenderEmail?: string | undefined;
    integrationJobGroupStatusChangeRecipients?: string | undefined;
    integrationJobLogStatusChangeRecipients?: string | undefined;
    integrationJobGroupStatusChangeCCRecipients?: string | undefined;
    integrationJobLogStatusChangeCCRecipients?: string | undefined;
    getBulkWriteoffsPageSize?: number;
    lateTimeThreshold?: number;
    disassociateButtonRoles?: string[] | undefined;
    careAttendDocumentTypes?: string[] | undefined;
    v4FaqSiteURL?: string | undefined;
    createEORPersonDefault?: boolean;
    defaultArea?: string | undefined;
    injectorLimit?: number;
    preciseDeductionTypes?: string[] | undefined;
    dailyWorkLimit?: number | undefined;
    rolesEligibleForShiftComments?: string[] | undefined;
    shiftCommentsLabel?: { [key: string]: string; } | undefined;
    shiftCommentsTitle?: { [key: string]: string; } | undefined;
    exclusionaryServiceConfig?: { [key: string]: string[]; } | undefined;
    rolesEligibleToViewTasksOnShiftSummary?: string[] | undefined;
    rolesEligibleToViewCommentsOnShiftSummary?: string[] | undefined;
    shiftSummaryCommentsTitle?: { [key: string]: string; } | undefined;
    startOfTheWeek?: string | undefined;
    taskConfigurationType?: string | undefined;
    stateCode?: string | undefined;
    searchDaysDifference?: number;
    relationshipWWL?: { [key: string]: number; } | undefined;
    solomonAdminShiftConfiguration?: SolomonAdminShiftConfiguration;
    testServiceCodeCommentsRequired?: string | undefined;
    dmcmAlternativeLabels?: { [key: string]: string; } | undefined;
    internalUseServiceCodes?: string[] | undefined;
    reminderNotification?: ReminderNotificationConfiguration;
    dmcmPersonTypes?: string[] | undefined;
    placeOfServiceOptions?: number[] | undefined;
    validationOverrideEnabled?: boolean;
}

export class CompanyInfo implements ICompanyInfo {
    features?: { [key: string]: boolean; } | undefined;
    configuration?: CompanyConfiguration;

    constructor(data?: ICompanyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)![key] = _data["features"][key];
                }
            }
            this.configuration = _data["configuration"] ? CompanyConfiguration.fromJS(_data["configuration"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompanyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = (<any>this.features)[key];
            }
        }
        data["configuration"] = this.configuration ? this.configuration.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICompanyInfo {
    features?: { [key: string]: boolean; } | undefined;
    configuration?: CompanyConfiguration;
}

export class ComponentDto implements IComponentDto {
    componentId?: number;
    componentName?: string | undefined;

    constructor(data?: IComponentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentId = _data["componentId"];
            this.componentName = _data["componentName"];
        }
    }

    static fromJS(data: any): ComponentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentId"] = this.componentId;
        data["componentName"] = this.componentName;
        return data;
    }
}

export interface IComponentDto {
    componentId?: number;
    componentName?: string | undefined;
}

export class ConfigurationDetailsRequest implements IConfigurationDetailsRequest {
    payor?: string | undefined;
    program?: string | undefined;
    componentId?: number;
    functionalGroupId?: number;
    features?: FeatureDto[] | undefined;

    constructor(data?: IConfigurationDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payor = _data["payor"];
            this.program = _data["program"];
            this.componentId = _data["componentId"];
            this.functionalGroupId = _data["functionalGroupId"];
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(FeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConfigurationDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payor"] = this.payor;
        data["program"] = this.program;
        data["componentId"] = this.componentId;
        data["functionalGroupId"] = this.functionalGroupId;
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IConfigurationDetailsRequest {
    payor?: string | undefined;
    program?: string | undefined;
    componentId?: number;
    functionalGroupId?: number;
    features?: FeatureDto[] | undefined;
}

export class ConfigurationDetailsResponse implements IConfigurationDetailsResponse {
    featureId?: number;
    companyId?: number;
    payorCode?: string | undefined;
    programCode?: string | undefined;
    featureValue?: string | undefined;
    mappingId?: number;

    constructor(data?: IConfigurationDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.featureId = _data["featureId"];
            this.companyId = _data["companyId"];
            this.payorCode = _data["payorCode"];
            this.programCode = _data["programCode"];
            this.featureValue = _data["featureValue"];
            this.mappingId = _data["mappingId"];
        }
    }

    static fromJS(data: any): ConfigurationDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["featureId"] = this.featureId;
        data["companyId"] = this.companyId;
        data["payorCode"] = this.payorCode;
        data["programCode"] = this.programCode;
        data["featureValue"] = this.featureValue;
        data["mappingId"] = this.mappingId;
        return data;
    }
}

export interface IConfigurationDetailsResponse {
    featureId?: number;
    companyId?: number;
    payorCode?: string | undefined;
    programCode?: string | undefined;
    featureValue?: string | undefined;
    mappingId?: number;
}

export class ConfigurationDto implements IConfigurationDto {
    payor?: string | undefined;
    program?: string | undefined;
    companyId?: number;
    featureName?: string | undefined;
    description?: string | undefined;
    valueType?: string | undefined;
    featureId?: number;
    featureValue?: any | undefined;

    constructor(data?: IConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payor = _data["payor"];
            this.program = _data["program"];
            this.companyId = _data["companyId"];
            this.featureName = _data["featureName"];
            this.description = _data["description"];
            this.valueType = _data["valueType"];
            this.featureId = _data["featureId"];
            this.featureValue = _data["featureValue"];
        }
    }

    static fromJS(data: any): ConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payor"] = this.payor;
        data["program"] = this.program;
        data["companyId"] = this.companyId;
        data["featureName"] = this.featureName;
        data["description"] = this.description;
        data["valueType"] = this.valueType;
        data["featureId"] = this.featureId;
        data["featureValue"] = this.featureValue;
        return data;
    }
}

export interface IConfigurationDto {
    payor?: string | undefined;
    program?: string | undefined;
    companyId?: number;
    featureName?: string | undefined;
    description?: string | undefined;
    valueType?: string | undefined;
    featureId?: number;
    featureValue?: any | undefined;
}

export class ConfigurationFetchRequest implements IConfigurationFetchRequest {
    payor?: string | undefined;
    componentId?: number;
    functionalGroupId?: number;
    program?: string | undefined;

    constructor(data?: IConfigurationFetchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payor = _data["payor"];
            this.componentId = _data["componentId"];
            this.functionalGroupId = _data["functionalGroupId"];
            this.program = _data["program"];
        }
    }

    static fromJS(data: any): ConfigurationFetchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationFetchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payor"] = this.payor;
        data["componentId"] = this.componentId;
        data["functionalGroupId"] = this.functionalGroupId;
        data["program"] = this.program;
        return data;
    }
}

export interface IConfigurationFetchRequest {
    payor?: string | undefined;
    componentId?: number;
    functionalGroupId?: number;
    program?: string | undefined;
}

export class DefaultEmployer implements IDefaultEmployer {
    ecn?: string | undefined;
    programType?: string | undefined;
    payor?: string | undefined;

    constructor(data?: IDefaultEmployer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ecn = _data["ecn"];
            this.programType = _data["programType"];
            this.payor = _data["payor"];
        }
    }

    static fromJS(data: any): DefaultEmployer {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultEmployer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ecn"] = this.ecn;
        data["programType"] = this.programType;
        data["payor"] = this.payor;
        return data;
    }
}

export interface IDefaultEmployer {
    ecn?: string | undefined;
    programType?: string | undefined;
    payor?: string | undefined;
}

export class FeatureDto implements IFeatureDto {
    featureId?: number;
    featureValue?: string | undefined;

    constructor(data?: IFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.featureId = _data["featureId"];
            this.featureValue = _data["featureValue"];
        }
    }

    static fromJS(data: any): FeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["featureId"] = this.featureId;
        data["featureValue"] = this.featureValue;
        return data;
    }
}

export interface IFeatureDto {
    featureId?: number;
    featureValue?: string | undefined;
}

export class FunctionalGroup implements IFunctionalGroup {
    functionalGroupId?: number;
    functionalGroupName?: string | undefined;

    constructor(data?: IFunctionalGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.functionalGroupId = _data["functionalGroupId"];
            this.functionalGroupName = _data["functionalGroupName"];
        }
    }

    static fromJS(data: any): FunctionalGroup {
        data = typeof data === 'object' ? data : {};
        let result = new FunctionalGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["functionalGroupId"] = this.functionalGroupId;
        data["functionalGroupName"] = this.functionalGroupName;
        return data;
    }
}

export interface IFunctionalGroup {
    functionalGroupId?: number;
    functionalGroupName?: string | undefined;
}

export class GracePeriod implements IGracePeriod {
    days?: number;
    isOverridable?: boolean;

    constructor(data?: IGracePeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.days = _data["days"];
            this.isOverridable = _data["isOverridable"];
        }
    }

    static fromJS(data: any): GracePeriod {
        data = typeof data === 'object' ? data : {};
        let result = new GracePeriod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["days"] = this.days;
        data["isOverridable"] = this.isOverridable;
        return data;
    }
}

export interface IGracePeriod {
    days?: number;
    isOverridable?: boolean;
}

export class GracePeriodConfiguration implements IGracePeriodConfiguration {
    default?: number;
    serviceCodeGracePeriods?: { [key: string]: GracePeriod; } | undefined;

    constructor(data?: IGracePeriodConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.default = _data["default"];
            if (_data["serviceCodeGracePeriods"]) {
                this.serviceCodeGracePeriods = {} as any;
                for (let key in _data["serviceCodeGracePeriods"]) {
                    if (_data["serviceCodeGracePeriods"].hasOwnProperty(key))
                        (<any>this.serviceCodeGracePeriods)![key] = _data["serviceCodeGracePeriods"][key] ? GracePeriod.fromJS(_data["serviceCodeGracePeriods"][key]) : new GracePeriod();
                }
            }
        }
    }

    static fromJS(data: any): GracePeriodConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new GracePeriodConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["default"] = this.default;
        if (this.serviceCodeGracePeriods) {
            data["serviceCodeGracePeriods"] = {};
            for (let key in this.serviceCodeGracePeriods) {
                if (this.serviceCodeGracePeriods.hasOwnProperty(key))
                    (<any>data["serviceCodeGracePeriods"])[key] = this.serviceCodeGracePeriods[key] ? this.serviceCodeGracePeriods[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IGracePeriodConfiguration {
    default?: number;
    serviceCodeGracePeriods?: { [key: string]: GracePeriod; } | undefined;
}

export class MileageServiceCodes implements IMileageServiceCodes {
    personalCare?: string | undefined;
    respite?: string | undefined;

    constructor(data?: IMileageServiceCodes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personalCare = _data["personalCare"];
            this.respite = _data["respite"];
        }
    }

    static fromJS(data: any): MileageServiceCodes {
        data = typeof data === 'object' ? data : {};
        let result = new MileageServiceCodes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personalCare"] = this.personalCare;
        data["respite"] = this.respite;
        return data;
    }
}

export interface IMileageServiceCodes {
    personalCare?: string | undefined;
    respite?: string | undefined;
}

export class PayorServiceCutoff implements IPayorServiceCutoff {
    payorName?: string | undefined;
    isEnabled?: boolean;
    cutoffDate?: string | undefined;

    constructor(data?: IPayorServiceCutoff) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payorName = _data["payorName"];
            this.isEnabled = _data["isEnabled"];
            this.cutoffDate = _data["cutoffDate"];
        }
    }

    static fromJS(data: any): PayorServiceCutoff {
        data = typeof data === 'object' ? data : {};
        let result = new PayorServiceCutoff();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payorName"] = this.payorName;
        data["isEnabled"] = this.isEnabled;
        data["cutoffDate"] = this.cutoffDate;
        return data;
    }
}

export interface IPayorServiceCutoff {
    payorName?: string | undefined;
    isEnabled?: boolean;
    cutoffDate?: string | undefined;
}

export class PersonTypeConfiguration implements IPersonTypeConfiguration {
    mapToInternalUser?: boolean;

    constructor(data?: IPersonTypeConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapToInternalUser = _data["mapToInternalUser"];
        }
    }

    static fromJS(data: any): PersonTypeConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new PersonTypeConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapToInternalUser"] = this.mapToInternalUser;
        return data;
    }
}

export interface IPersonTypeConfiguration {
    mapToInternalUser?: boolean;
}

export class ReminderNotificationConfiguration implements IReminderNotificationConfiguration {
    emailFrom?: string | undefined;
    emailSubject?: string | undefined;
    emailMsgBody?: string | undefined;
    smsFrom?: string | undefined;
    smsMsgBody?: string | undefined;
    minsLookbackBegin?: number;
    minsLookbackEnd?: number;
    priority?: number;

    constructor(data?: IReminderNotificationConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailFrom = _data["emailFrom"];
            this.emailSubject = _data["emailSubject"];
            this.emailMsgBody = _data["emailMsgBody"];
            this.smsFrom = _data["smsFrom"];
            this.smsMsgBody = _data["smsMsgBody"];
            this.minsLookbackBegin = _data["minsLookbackBegin"];
            this.minsLookbackEnd = _data["minsLookbackEnd"];
            this.priority = _data["priority"];
        }
    }

    static fromJS(data: any): ReminderNotificationConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new ReminderNotificationConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailFrom"] = this.emailFrom;
        data["emailSubject"] = this.emailSubject;
        data["emailMsgBody"] = this.emailMsgBody;
        data["smsFrom"] = this.smsFrom;
        data["smsMsgBody"] = this.smsMsgBody;
        data["minsLookbackBegin"] = this.minsLookbackBegin;
        data["minsLookbackEnd"] = this.minsLookbackEnd;
        data["priority"] = this.priority;
        return data;
    }
}

export interface IReminderNotificationConfiguration {
    emailFrom?: string | undefined;
    emailSubject?: string | undefined;
    emailMsgBody?: string | undefined;
    smsFrom?: string | undefined;
    smsMsgBody?: string | undefined;
    minsLookbackBegin?: number;
    minsLookbackEnd?: number;
    priority?: number;
}

export class SolomonAdminShiftConfiguration implements ISolomonAdminShiftConfiguration {
    agreementNumber?: string | undefined;
    participantID?: string | undefined;
    program?: string | undefined;
    subAccount?: string | undefined;

    constructor(data?: ISolomonAdminShiftConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agreementNumber = _data["agreementNumber"];
            this.participantID = _data["participantID"];
            this.program = _data["program"];
            this.subAccount = _data["subAccount"];
        }
    }

    static fromJS(data: any): SolomonAdminShiftConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new SolomonAdminShiftConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agreementNumber"] = this.agreementNumber;
        data["participantID"] = this.participantID;
        data["program"] = this.program;
        data["subAccount"] = this.subAccount;
        return data;
    }
}

export interface ISolomonAdminShiftConfiguration {
    agreementNumber?: string | undefined;
    participantID?: string | undefined;
    program?: string | undefined;
    subAccount?: string | undefined;
}

export class ThresholdRulesConfig implements IThresholdRulesConfig {
    maxBillUnit?: number;
    maxBillTotal?: number;
    maxPayUnit?: number;
    maxPayTotal?: number;

    constructor(data?: IThresholdRulesConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxBillUnit = _data["maxBillUnit"];
            this.maxBillTotal = _data["maxBillTotal"];
            this.maxPayUnit = _data["maxPayUnit"];
            this.maxPayTotal = _data["maxPayTotal"];
        }
    }

    static fromJS(data: any): ThresholdRulesConfig {
        data = typeof data === 'object' ? data : {};
        let result = new ThresholdRulesConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxBillUnit"] = this.maxBillUnit;
        data["maxBillTotal"] = this.maxBillTotal;
        data["maxPayUnit"] = this.maxPayUnit;
        data["maxPayTotal"] = this.maxPayTotal;
        return data;
    }
}

export interface IThresholdRulesConfig {
    maxBillUnit?: number;
    maxBillTotal?: number;
    maxPayUnit?: number;
    maxPayTotal?: number;
}

export class TimeZoneConfig implements ITimeZoneConfig {
    id?: string | undefined;
    name?: string | undefined;
    location?: string | undefined;

    constructor(data?: ITimeZoneConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.location = _data["location"];
        }
    }

    static fromJS(data: any): TimeZoneConfig {
        data = typeof data === 'object' ? data : {};
        let result = new TimeZoneConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["location"] = this.location;
        return data;
    }
}

export interface ITimeZoneConfig {
    id?: string | undefined;
    name?: string | undefined;
    location?: string | undefined;
}

export class V4RoleScreensConfig implements IV4RoleScreensConfig {
    outstandingMileageEntries?: { [key: string]: string[]; } | undefined;
    outstandingTimeEntries?: { [key: string]: string[]; } | undefined;
    timeAndMileageEntriesButton?: { [key: string]: string[]; } | undefined;
    shiftMileageEntries?: { [key: string]: string[]; } | undefined;

    constructor(data?: IV4RoleScreensConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["outstandingMileageEntries"]) {
                this.outstandingMileageEntries = {} as any;
                for (let key in _data["outstandingMileageEntries"]) {
                    if (_data["outstandingMileageEntries"].hasOwnProperty(key))
                        (<any>this.outstandingMileageEntries)![key] = _data["outstandingMileageEntries"][key];
                }
            }
            if (_data["outstandingTimeEntries"]) {
                this.outstandingTimeEntries = {} as any;
                for (let key in _data["outstandingTimeEntries"]) {
                    if (_data["outstandingTimeEntries"].hasOwnProperty(key))
                        (<any>this.outstandingTimeEntries)![key] = _data["outstandingTimeEntries"][key];
                }
            }
            if (_data["timeAndMileageEntriesButton"]) {
                this.timeAndMileageEntriesButton = {} as any;
                for (let key in _data["timeAndMileageEntriesButton"]) {
                    if (_data["timeAndMileageEntriesButton"].hasOwnProperty(key))
                        (<any>this.timeAndMileageEntriesButton)![key] = _data["timeAndMileageEntriesButton"][key];
                }
            }
            if (_data["shiftMileageEntries"]) {
                this.shiftMileageEntries = {} as any;
                for (let key in _data["shiftMileageEntries"]) {
                    if (_data["shiftMileageEntries"].hasOwnProperty(key))
                        (<any>this.shiftMileageEntries)![key] = _data["shiftMileageEntries"][key];
                }
            }
        }
    }

    static fromJS(data: any): V4RoleScreensConfig {
        data = typeof data === 'object' ? data : {};
        let result = new V4RoleScreensConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.outstandingMileageEntries) {
            data["outstandingMileageEntries"] = {};
            for (let key in this.outstandingMileageEntries) {
                if (this.outstandingMileageEntries.hasOwnProperty(key))
                    (<any>data["outstandingMileageEntries"])[key] = (<any>this.outstandingMileageEntries)[key];
            }
        }
        if (this.outstandingTimeEntries) {
            data["outstandingTimeEntries"] = {};
            for (let key in this.outstandingTimeEntries) {
                if (this.outstandingTimeEntries.hasOwnProperty(key))
                    (<any>data["outstandingTimeEntries"])[key] = (<any>this.outstandingTimeEntries)[key];
            }
        }
        if (this.timeAndMileageEntriesButton) {
            data["timeAndMileageEntriesButton"] = {};
            for (let key in this.timeAndMileageEntriesButton) {
                if (this.timeAndMileageEntriesButton.hasOwnProperty(key))
                    (<any>data["timeAndMileageEntriesButton"])[key] = (<any>this.timeAndMileageEntriesButton)[key];
            }
        }
        if (this.shiftMileageEntries) {
            data["shiftMileageEntries"] = {};
            for (let key in this.shiftMileageEntries) {
                if (this.shiftMileageEntries.hasOwnProperty(key))
                    (<any>data["shiftMileageEntries"])[key] = (<any>this.shiftMileageEntries)[key];
            }
        }
        return data;
    }
}

export interface IV4RoleScreensConfig {
    outstandingMileageEntries?: { [key: string]: string[]; } | undefined;
    outstandingTimeEntries?: { [key: string]: string[]; } | undefined;
    timeAndMileageEntriesButton?: { [key: string]: string[]; } | undefined;
    shiftMileageEntries?: { [key: string]: string[]; } | undefined;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
